import $ from 'jquery';

$(document).ready(function(){

    $( ".variations_form select" ).on( "change", function () {
        let parentForm = $(this).parents('.variations_form');
        let variationData = $(".variations_form").data('product_variations');
        let attributs = [];
        parentForm.find('select').each(function(){
            if (! attributs.includes($(this).attr('name'))) {
                attributs.push($(this).attr('name'));
            }
        });
        let i = 0;
        let variation_found = false;

        while (! variation_found) {
            variation_found = true;
            attributs.forEach(one_attribut => {

                if ( (variation_found) && (variationData[i]['attributes'][one_attribut] !== parentForm.find('select[name="' + one_attribut + '"]')[0].value) ) {
                    variation_found = false;
                }
            });
            if ( ! variation_found) {
                i++;
            }
        }
        $('.product[data-id]').attr('data-id', variationData[i]['variation_id']);
        $('.product[data-price]').attr('data-price', variationData[i]['display_price']);
        let items = [];
        items.push({
            'item_id': $('.product').attr('data-id'),
            'item_name': $('.product').attr('data-name'),
            'currency': 'EUR',
            'discount': $('.product').attr('data-discount'),
            'item_brand': 'www.quies.fr',
            'item_category': $('.product').attr('data-cat'),
            'item_category2':$('.product').attr('data-type'),
            'price': $('.product').attr('data-price')
        });

        dataLayer.push({ ecommerce: null});
        dataLayer.push({
            'event': 'view_item',
            'currency': 'EUR',
            'value': $('.product').attr('data-price') - $('.product').attr('data-discount'),
            'ecommerce': {
                'items': items
            }
        });
    });

    $( ".woocommerce-cart form#cart" ).on( 'submit', function(event){
        let coupon = $( ".woocommerce-cart form#cart #coupon_code" ).val();
        if (coupon) {
            event.preventDefault();
            $.ajax({
                url: quies.ajaxurl,
                data: {action : 'coupon_handling', couponcode : coupon},
                type: 'POST',
                success:function(data){
                    let data_json = JSON.parse(data);
                    $.when( taggingCoupon(data_json.coupon, data_json.return) ).done(function() {
                        setTimeout( () => {window.location.reload()}, 1000 )
                    });

                }
            });
        }
    });


    function taggingCoupon(coupon, is_valid){
        if (is_valid) {

            let dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'add_discount_code',
                'discount_code_id': coupon,
            });
        }
    }

});

const tagging = () => {


    let dataLayer = window.dataLayer || [];

    //view_item
    if ($('body').hasClass('single-product')) {
        let product = document.querySelector('#main .product');
        let tags = get_tags_values_from_data_attributes(product);
        let items = [];

        items.push({
            'item_id': tags['id'],
            'item_name': tags['name'],
            'currency': 'EUR',
            'discount': tags['discount'],
            'item_brand': 'www.quies.fr',
            'item_category': tags['cat'],
            'item_category2': tags['type'],
            'price': tags['price']
        });

        dataLayer.push({ ecommerce: null});
        dataLayer.push({
            'event': 'view_item',
            'currency': 'EUR',
            'value': $('.product').attr('data-price') - $('.product').attr('data-discount'),
            'ecommerce': {
                'items': items
            }
        });
    }

    //view_cart
    if((document.querySelectorAll('body.woocommerce-cart')||[]).length) {
        let items = [];
        let value = 0;
        document.querySelectorAll('.products-list .current-product').forEach(element => {
            let tags = get_tags_values_from_data_attributes(element, "products-list", "current-product");
            let quantity = element.querySelector('input.qty').value;
            value += quantity * (tags['price'] - tags['discount']);
            items.push({
                'item_id': tags['id'],
                'item_name': tags['name'],
                'currency': 'EUR',
                'discount': tags['discount'],
                'index': tags['index'],
                'quantity': element.querySelector('input.qty').value,
                'item_brand': 'www.quies.fr',
                'item_category': tags['cat'],
                'item_category2': tags['type'],
                'item_list_name': 'cart pages',
                'price': tags['price']
            });

        });

        dataLayer.push({ ecommerce: null});
        dataLayer.push({
            event: 'view_cart',
            currency: 'EUR',
            value: value,
            ecommerce: {
                items: items
            }
        });
    }

    //view_list_item
    if((document.querySelectorAll('.products-loop .product')||[]).length) {

        taggingOnWindowScroll();
        window.addEventListener('scroll', taggingOnWindowScroll);

    }

    //add_to_wishlist
    if((document.querySelectorAll('#product-gallery-desktop .links-top')||[]).length) {

        document.querySelector('#product-gallery-desktop .links-top .woosw-btn').addEventListener('click', function (event) {
            if (event.target.getAttribute('data-id')) {
                let prod_id = event.target.getAttribute('data-id');
                let prod_cat = document.querySelector("#main > .product-container").getAttribute('data-cat');
                dataLayer.push({
                    'event': 'add_to_wishlist',
                    'product_id': prod_id,
                    'page_universe': prod_cat
                });
            }
            ;
        });
    }

    //

    if((document.querySelectorAll('.product:not(.woosw-content-item) .single_add_to_cart_button')||[]).length) {
        document.querySelectorAll('.product:not(.woosw-content-item) .single_add_to_cart_button').forEach(element => {
            element.addEventListener('click', function (event) {
                let product = element.closest('.product');
                let current_qty = product.querySelector('.input-text.qty').value;
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'add_to_cart',
                    currency: 'EUR',
                    value: current_qty * (product.getAttribute('data-price') - product.getAttribute('data-discount')),
                    ecommerce: {
                        items: [
                            {
                                item_id: product.getAttribute('data-id'),
                                item_name: product.getAttribute('data-name'),
                                currency: 'EUR',
                                discount: product.getAttribute('data-discount'),
                                index: '',
                                item_brand: 'www.quies.fr',
                                item_category: product.getAttribute('data-cat'),
                                item_category2: product.getAttribute('data-type'),
                                item_list_id: 'product_pages',
                                item_list_name: product.getAttribute('data-list-name'),
                                price: product.getAttribute('data-price'),
                                quantity: current_qty,
                            }
                        ]
                    }
                });
            });

        });
    }

    //click download_product_constitution
    if((document.querySelectorAll('.product-content a.download-link')||[]).length) {
        document.querySelectorAll('.product-content a.download-link').forEach(element => {
            element.addEventListener('click', function (event) {
                dataLayer.push({
                    'event': 'click',
                    'page_template': 'Product',
                    'event_label': 'download_product_constitution',
                    'event_action': 'download'
                });
            });
        });
    }

    //click click_product_details
    if((document.querySelectorAll('.product-content .tabs li a')||[]).length) {
        document.querySelectorAll('.product-content .tabs li a').forEach(element => {
            element.addEventListener('click', function (event) {
                dataLayer.push({
                    'event': 'click',
                    'page_template': 'Product',
                    'event_label': 'click_product_details',
                    'event_action': 'click'
                });
            });

        });
    }

    //click video
    if((document.querySelectorAll('.product-content .youtube-player')||[]).length) {
        document.querySelectorAll('.product-content .youtube-player').forEach(element => {
            element.addEventListener('click', function (event) {
                dataLayer.push({
                    'event': 'click',
                    'page_template': 'Product',
                    'event_label': element.getAttribute('data-id'),
                    'event_action': 'play'
                });
            });
        });
    }

    //select_item
    if((document.querySelectorAll('.products-loop .product')||[]).length) {

        document.querySelectorAll('.products-loop .product').forEach(element => {
            element.addEventListener('click', function (event) {

                if (this.getAttribute('data-id')) {
                    let prod_id = this.getAttribute('data-id');
                    let prod_name = this.getAttribute('data-name');
                    let prod_discount = this.getAttribute('data-discount');
                    let all_products = this.closest(".products-loop").querySelectorAll('.product'); // all .product in parent.products-loop
                    let index = 0;
                    while (all_products[index].getAttribute('data-id') !== this.getAttribute('data-id')) {
                        index++;
                    }
                    let prod_list_name = this.getAttribute('data-list-name');
                    let prod_price = this.getAttribute('data-price');
                    let prod_cat = this.getAttribute('data-cat');
                    let prod_type = this.getAttribute('data-type');
                    dataLayer.push({ecommerce: null});
                    dataLayer.push({
                        'event': 'select_item',
                        'ecommerce': {
                            items: [
                                {
                                    'item_id': prod_id,
                                    'item_name': prod_name,
                                    'currency': 'EUR',
                                    'discount': prod_discount,
                                    'index': index,
                                    'item_brand': 'www.quies.fr',
                                    'item_category': prod_cat,
                                    'item_category2': prod_type,
                                    'item_list_name': prod_list_name,
                                    'price': prod_price,
                                }
                            ]
                        }
                    });
                }
            });
        });
    }

    //faq_click
    if((document.querySelectorAll('#faq .question')||[]).length) {
        document.querySelectorAll('#faq .question').forEach(element => {
            element.addEventListener('click', function (event) {
                if (event.target.getAttribute('data-id')) {
                    let question_id = event.target.getAttribute('data-id');
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'click',
                        'page_template': 'Faq',
                        'event_label': 'click_faq_' + question_id,
                        'event_action': 'click',
                    });
                }
            });
        });
    }


    if((document.querySelectorAll('.slick-dots button')||[]).length) {
        document.querySelectorAll('.slick-dots button').forEach(element => {
            element.addEventListener('click', function(event){
                triggerTagging();
            })
        });
    }



    //add_to_cart form wishlist
    if((document.querySelectorAll('.woosw-list .product')||[]).length) {
        document.querySelectorAll('.woosw-list .product').forEach(element => {
            element.addEventListener('click', function(event){
                if (event.target.classList.contains('add_to_cart_button')) {
                    let tags = get_tags_values_from_data_attributes(this, "products-loop", "product")
                    if (tags['id']) {
                        dataLayer.push({ecommerce: null});
                        dataLayer.push({
                            'event': 'add_to_cart',
                            'currency': 'EUR',
                            'value': tags['price'] - tags['discount'],
                            'ecommerce': {
                                items: [
                                    {
                                        'item_id': tags['id'],
                                        'item_name': tags['name'],
                                        'currency': 'EUR',
                                        'discount': tags['discount'],
                                        'index': tags['index'],
                                        'item_brand': 'www.quies.fr',
                                        'item_category': tags['cat'],
                                        'item_category2': tags['type'],
                                        'item_list_name': 'wishlist',
                                        'price': tags['price']
                                    }
                                ]
                            }
                        });
                    }
                }
            })
        });
    }

    //remove_from_cart from mini-cart
    if((document.querySelectorAll('.header-panier')||[]).length) {
        document.querySelectorAll('.header-panier').forEach(parentEl => {
            parentEl.addEventListener('click', event => {
               if (event.target.classList.contains('remove_from_cart_button')) {
                   let element = event.target;
                   let product = element.closest('.mini_cart_item');
                   let current_qty = product.getAttribute("data-qty");
                   let tags = get_tags_values_from_data_attributes(product, "woocommerce-mini-cart", "mini_cart_item");
                   dataLayer.push({ecommerce: null});
                   dataLayer.push({
                       'event': 'remove_from_cart',
                       'currency': 'EUR',
                       'value': current_qty * (tags['price'] - tags['discount']),
                       'ecommerce': {
                           items: [
                               {
                                   'item_id': tags['id'],
                                   'item_name': tags['name'],
                                   'currency': 'EUR',
                                   'discount': tags['discount'],
                                   'index': tags['index'],
                                   'item_brand': 'www.quies.fr',
                                   'item_category': tags['cat'],
                                   'item_category2': tags['type'],
                                   'item_list_name': 'mini_cart',
                                   'price': tags['price'],
                                   'quantity': current_qty
                               }
                           ]
                       }
                   });
               }
           });
        });
    }

    //add_to_cart and _remove_from_cart from cart pages
    if((document.querySelectorAll('body.woocommerce-cart .products-list .current-product')||[]).length) {
        let cart_products = document.querySelectorAll('body.woocommerce-cart .products-list .current-product');
        let quantities = [];
        cart_products.forEach(element =>{
            quantities[element.getAttribute('data-id')] = element.querySelector('.input-text.qty').value;
        });

        document.querySelector("#cart button.button[name=update_cart]:not(disabled)").addEventListener('click', event => {
            cart_products.forEach(element =>{
                let current_qty = element.querySelector('.input-text.qty').value;
                let actual_qty = current_qty;
                if (quantities[element.getAttribute('data-id')] !== current_qty) {
                    let tags = get_tags_values_from_data_attributes(element, "products-list", "current-product");
                    let event_name = "";
                    if (quantities[element.getAttribute('data-id')] < current_qty) {
                        event_name = 'add_to_cart';
                        actual_qty = current_qty - quantities[element.getAttribute('data-id')] ;
                    } else {
                        event_name = 'remove_from_cart';
                        actual_qty = quantities[element.getAttribute('data-id')] - current_qty;
                    }
                    dataLayer.push({ecommerce: null});
                    dataLayer.push({
                        'event': event_name,
                        'currency': 'EUR',
                        'value': (tags['price'] - tags['discount']) * actual_qty,
                        'ecommerce': {
                            items: [
                                {
                                    'item_id': tags['id'],
                                    'item_name': tags['name'],
                                    'currency': 'EUR',
                                    'discount': tags['discount'],
                                    'index': tags['index'],
                                    'item_brand': 'www.quies.fr',
                                    'item_category': tags['cat'],
                                    'item_category2': tags['type'],
                                    'item_list_name': 'cart_pages',
                                    'price': tags['price'],
                                    'quantity': actual_qty
                                }
                            ]
                        }
                    });
                }
            });
        });

        document.querySelectorAll("#cart .current-product__actions a.remove").forEach(element => {
            element.addEventListener('click', event => {
                let product = element.closest('.current-product');
                let current_qty = product.querySelector('.input-text.qty').value;
                let tags = get_tags_values_from_data_attributes(product, "products-list", "current-product");
                dataLayer.push({ecommerce: null});
                dataLayer.push({
                    'event': 'remove_from_cart',
                    'currency': 'EUR',
                    'value': current_qty * (tags['price'] - tags['discount']),
                    'ecommerce': {
                        items: [
                            {
                                'item_id': tags['id'],
                                'item_name': tags['name'],
                                'currency': 'EUR',
                                'discount': tags['discount'],
                                'index': tags['index'],
                                'item_brand': 'www.quies.fr',
                                'item_category': tags['cat'],
                                'item_category2': tags['type'],
                                'item_list_name': 'cart_pages',
                                'price': tags['price'],
                                'quantity': current_qty
                            }
                        ]
                    }
                });
            });
        });
    }

    //click share_social_media
    if((document.querySelectorAll('#article .share-link')||[]).length) {
        document.querySelectorAll("#article .share-link").forEach(element => {
            element.addEventListener('click', event => {
                dataLayer.push({
                    'event': 'click',
                    'page_template': 'Blog',
                    'event_label': 'share_social_media',
                    'event_action': 'share'
                });
            });
        });
    }

    //click share_product
    if((document.querySelectorAll('.product .product-share-link')||[]).length) {
        document.querySelectorAll(".product .product-share-link").forEach(element => {
            element.addEventListener('click', event => {
                dataLayer.push({
                    'event': 'click',
                    'page_template': 'Product',
                    'event_label': 'share_product',
                    'event_action': 'share'
                });
            });
        });
    }

    //sign_up
    if ( typeof mc4wp !== 'undefined' ) {
        mc4wp.forms.on('subscribed', function(form) {
            window.dataLayer = window.dataLayer || [];
            if (form.element.getAttribute('id') === 'mc4wp-form-1') {
                window.dataLayer.push({ 'event' : 'subscribe_newsletter', 'subscription_type': 'footer' });
            }
            if (form.element.getAttribute('id') === 'mc4wp-form-2') {
                window.dataLayer.push({ 'event' : 'subscribe_newsletter', 'subscription_type': 'pop_in' });
            }
        });
    }

    $('.slider-homepage').on('swipe', function (event, slick, currentSlide, nextSlide) {
        triggerTagging();
    });

    function triggerTagging(){
        let dataLayer = window.dataLayer;
        dataLayer.push({
            'event': 'click',
            'page_template': 'Homepage',
            'event_label': 'click_homepage_carroussel',
            'event_action': 'click'
        });
    }

    function get_tags_values_from_data_attributes(element, parentClass = "", siblingClass =""){

        let tags = []
        tags['id'] = element.getAttribute('data-id');
        tags['name'] = element.getAttribute('data-name');
        tags['discount'] = element.getAttribute('data-discount');
        if (parentClass) {
            let all_products = element.closest('.' + parentClass).querySelectorAll('.' + siblingClass); // all .product in parent.products-loop
            let index = 0;
            while (all_products[index].getAttribute('data-id') !== element.getAttribute('data-id')) {
                index++;
            }
            tags['index'] = index;
        }
        tags['list_name'] = element.getAttribute('data-list-name');
        tags['price'] = element.getAttribute('data-price');
        tags['cat'] = element.getAttribute('data-cat');
        tags['type'] = element.getAttribute('data-type');

        return tags;
    }

    function checkVisible( elm ) {

        let vpH = $(window).height(), // Viewport Height
                st = $(window).scrollTop(), // Scroll Top
                y = $(elm).offset().top,
                elementHeight = $(elm).height();

        return ((y < (vpH + st)) && (y > (st - elementHeight)));
    }

    function taggingOnWindowScroll() {
        let items = [];
        document.querySelectorAll('.products-loop .product:not(.list-triggered)').forEach(element => {
            if(checkVisible(element)) {
                let tags = get_tags_values_from_data_attributes(element, "products-loop", "product");
                items.push({
                    'item_id': tags['id'],
                    'item_name': tags['name'],
                    'currency': 'EUR',
                    'discount': tags['discount'],
                    'index': tags['index'],
                    'item_brand': 'www.quies.fr',
                    'item_category': tags['cat'],
                    'item_category2': tags['type'],
                    'item_list_name': tags['list_name'],
                    'price': tags['price']
                });
                $(element).addClass('list-triggered');
            }
        });

        if (items.length) {
            dataLayer.push({
                event: 'view_item_list',
                ecommerce: {
                    items: items
                }
            });
        }
    }
}

export default tagging;
